var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.747 5.634c-.7-3.08-3.387-4.467-5.747-4.467h-.007c-2.353 0-5.046 1.38-5.746 4.46-.78 3.44 1.326 6.353 3.233 8.187A3.62 3.62 0 0 0 8 14.834c.907 0 1.813-.34 2.513-1.02 1.907-1.834 4.014-4.74 3.234-8.18",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 8.973a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2"
  })));
};
export default SvgLocation;